import {SettingsPanelApi} from '../api/SettingsPanelApi';
import {BaseValidatedClass} from '../BaseValidatedClass';

import {SettingsPanelTab} from './SettingsPanelTab';

interface SettingsPanelTabMap {
  registerBlockControls(_blockControlsMap: Record<string, SettingsPanelTab[]>): void;
}

export class SettingsPanelRegistry extends BaseValidatedClass implements SettingsPanelTabMap {
  public api!: SettingsPanelApi;

  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS: (keyof SettingsPanelTabMap)[] = ['registerBlockControls'];

  constructor() {
    super(SettingsPanelRegistry.REQUIRED_METHODS, SettingsPanelRegistry);
  }

  public registerBlockControls(_blockControlsMap: Record<string, SettingsPanelTab[]>): void {
    throw new Error('Method registerBlockControls() must be implemented by the subclass');
  }
}
